const ClassicItems = [
  {
    id: 1,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 2,
    image: "",
    image2: "",
    image3: "",
    price: "Rs. 629",
    name: "",
    description: "",
  },
  {
    id: 3,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 4,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 5,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 6,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 7,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 8,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 9,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 10,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 11,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 12,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 13,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 14,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 15,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
  {
    id: 16,
    image: "",
    image2: "",
    image3: "",
    price: "",
    name: "",
    description: "",
  },
];

export default ClassicItems;
